import React from "react";

function About() {
  return (
    <>
      <div className="history-heading">
        <h3>About</h3>
      </div>
      <div className="about-parent">
        <div className="about-pic"></div>

        <div className="about-desc">
          <p>
            From mechanical Engineering to mainframes, and from mainframes to
            machine learning, My journey has never been easy. To start with-
            Mainframes was never my choice, but I was chosen by chance. I
            decided to look inside of it by exploring its backbone- the
            database(DB2). I worked as a DBA and mantained the DBs for some
            time. However I could not get excited in it, as it was more of a
            backend work.
          </p>
          <br />
          <p>
            That pushed me towards finding interest in the front end frameworks.
            With changes reflecting on UI - at finger tips, mainframes to UI
            transition was more exciting, at the same time a bumpy ride.
            Javascript, Angular & React gave me some company during this period
            and kept me engaging. But somewhere in the line, I found a new
            friend - computer vision. It had lot of dependancies - python
            programming, Machine learning, and then neural networks. Not only
            that, there is this debate - between pytorch and tensorflow.
            However, I am still a bird who is learning to fly.
          </p>
          <br />
          <p>
            Interest in computer vision made me participate in small
            challenges(during hackathons). I always found happiness when I
            implemented an algo. At a later point, this interest encouraged me
            to continue my academics(with the goal that I wanted to share my
            knowledge), now turned it into a full time researcher. I mixed it
            with my hobby (playing badminton), to analyze the grip dynamics. I
            would like to help younger generation coaches/players using my
            research to improve their technique.
          </p>

          <p>
            I already told enough about me. Perhaps lets connect, if this
            generates interest on me.
          </p>
        </div>
      </div>
    </>
  );
}

export default About;
